// extracted by mini-css-extract-plugin
export default {"mainContainer":"login_mainContainer__-n7FF","title":"login_title__BD09y","subtitle":"login_subtitle__vxKxe"};